<template>
  <div class="w-full h-full flex flex-col">

    <page-hero bg="about" :title="page.title" :subtitle="page.sub_title">
      <template #title>
        We don’t have clients we have <span class="text-primary1"> partners</span>
      </template>
    </page-hero>

<!--    hello section-->
    <div class="w-full h-full flex-col items-start mt-32 mb-16 px-4 md:px-12">
      <div class="w-full h-1/3 flex justify-between flex-col-reverse md:flex-row gap-10 md:gap-20 max-w-content mx-auto ">
        <div class="w-full md:w-1/2 relative">
          <img
            :src="galleryImage"
            :alt="galleryImage === defaultGallery ? '' : 'Digital Threads'"
            class="w-full h-500p object-contain object-center"
          />
        </div>
        <div class="w-full md:w-1/3 flex flex-col gap-4">
          <div class="text-32 text-primary1 text-left ">Hello</div>
          <div class="text-18p text-black text-left">
            We are Digital Threads!
            <div>We always focus on a partnership model and building long term relationships with our clients. So, our focus is always the best interests of our customers. Company
            founded to deliver technology solutions that positively impact the business. We endeavor to build long-term partnerships with our clients, and that has been the secret to our success.</div>
          </div>
        </div>
      </div>
    </div>



<!--    How we can help your business grow sectio-->
    <section-layout class="max-w-content m-auto">
      <template #title>
        How we can help your business grow
      </template>

      <div class="mx-auto flex flex-wrap justify-center gap-x-8 gap-y-12 pb-16 container-md m-auto">
        <about-help-your-business-card v-for="item in yourBusinessCardData" :key="item.id" class="w-full sm:w-400p">
          <template #title>
            {{ item.title }}
          </template>

          <template #description>
            {{ item.description }}
          </template>
        </about-help-your-business-card>
      </div>
    </section-layout>


<!--    Workflow section-->
    <section-layout class="pt-0 md:pt-0 pr-0" id="workflow">
      <template #title>
        Workflow
      </template>

      <template #subtitle>
        Our web development experts are ready to empower your business with a software of any type and difficulty.
      </template>

      <div class="w-full flex justify-between flex-col-reverse md:flex-row gap-12 md:gap-0">

        <div class="w-full md:w-1/2 flex flex-col items-start gap-8 md:gap-24">
          <div class="w-full flex relative gap-2" v-for="(item, index) in workflowData" :key="item.id" data-aos="fade-up" :data-aos-delay="index * 80">
            <div v-html="item.icon" />
            <div class="w-full flex flex-col gap-2 items-start justify-start">
              <div class="text-dark-cerulean text-18 font-bold">
                {{ item.title }}
              </div>
              <div class="text-black text-16 font-normal text-left opacity-50">
                {{ item.description }}
              </div>
            </div>
            <div v-html="item.numIcon" class="hidden md:block"/>
            <div v-if="index !== workflowData.length-1" class="hidden md:block w-2 h-full bg-step-line bg-no-repeat absolute -right-4 top-40"></div>
          </div>
        </div>

        <div class="w-full md:w-1/2 flex items-center justify-start md:justify-end">
          <img src="@/assets/backgrounds/workflow-section.png" alt="Our workflow, from first contact to post-project communication" class="block md:hidden">
          <div class="bg-workflow bg-no-repeat bg-cover h-800p w-full hidden md:block md:w-3/4"/>
        </div>

      </div>
    </section-layout>


<!--    peoples section-->
    <section-layout class="pt-0 md:pt-0 pb-96p">
      <template #title>
        People
      </template>

      <template #subtitle>
        Alone we can do so little, together we can do much more!
      </template>

      <div class="w-full flex flex-wrap justify-center gap-8">

        <div
          v-for="(people, index) in peoplesData"
          :key="people.id"
          class="person h-full flex items-center justify-center flex-col"
          data-aos="fade-up"
          :data-aos-delay="(index % 4) * 90"
        >
          <!-- фото приходит из админки; пока не загружено — обезличенная заглушка,
               чтобы на странице не висели снимки прежних сотрудников -->
          <img
            :src="people.photoUrl || defaultAvatar"
            :alt="people.photoUrl ? `${people.fullName}, ${people.position}` : ''"
            class="person-photo w-300p h-320p object-cover object-center rounded-70p shadow-4xl"
          />
          <div class="w-full text-navy text-center text-24 font-bold">
            {{ people.fullName }}
          </div>
          <div class="text-navy text-18 font-normal">
            {{ people.position }}
          </div>
          <a
            v-if="people.linkedin"
            :href="people.linkedin"
            target="_blank"
            rel="noopener"
            class="person-link mt-1 p-2.5"
            :aria-label="`${people.fullName} on LinkedIn`"
          >
            <svg class="w-6 h-6" viewBox="0 0 20 21" fill="currentColor" aria-hidden="true">
              <path d="M7.429 7.207h3.714v1.85c.535-1.064 1.907-2.02 3.968-2.02 3.951 0 4.889 2.118 4.889 6.004v7.197h-4v-6.312c0-2.213-.535-3.461-1.897-3.461-1.889 0-2.674 1.345-2.674 3.46v6.313h-4V7.207ZM.57 20.068h4V7.037h-4v13.031ZM5.143 2.75a2.57 2.57 0 1 1-5.143 0 2.57 2.57 0 0 1 5.143 0Z"/>
            </svg>
          </a>
        </div>

        <div class=" h-full flex items-center justify-center flex-col gap-2 cursor-pointer" data-aos="fade-up" :data-aos-delay="peoplesData.length % 4 * 90" @click="$router.push('/careers#open-position')">
          <div class="join-card w-300p h-320p flex items-center justify-center flex-col shadow-4xl cursor-pointer rounded-70p border border-transparent px-10 gap-6 text-center">
            <div class="text-navy text-20 font-bold leading-snug">See what open positions we have for you</div>
            <div class="join-arrow bg-go-to w-8 h-4 bg-no-repeat bg-contain"> </div>
          </div>
        </div>

      </div>
    </section-layout>

  </div>
</template>

<script>
export default {
  name: 'About',
}
</script>

<script setup>
import SectionLayout from '@/layouts/SectionLayout'
import AboutHelpYourBusinessCard from '@/components/About/AboutHelpYourBusinessCard'
import { computed } from 'vue'
import { useContent } from '@/composables/useContent'
import PageHero from '@/components/PageHero'

const defaultBusinessCards = [
  {
    id: 1,
    title: 'Quality vs Quantity',
    description: `That’s the key to our philosophy. We strive to deliver the best service and create the highest quality products by constantly
                  renewing and improving every aspect of our process.`
  },
  {
    id: 2,
    title: 'Strong Relationships',
    description: `We build strong, trusting relationships with our clients and encourage close bonds among our team members.`
  },
  {
    id: 3,
    title: 'Passion and Commitment',
    description: `We are passionate about our work. We are enthusiastic about the work we do and the products we help build. We respect our
                  clients; we put ourselves in their shoes, always listening to everyone’s opinions in order to contribute to new ideas.`
  },
  {
    id: 4,
    title: 'Team over Individuals',
    description: `We are passionate about our work. We are enthusiastic about the work we do and the products we help build. We respect our
                  clients; we put ourselves in their shoes, always listening to everyone’s opinions in order to contribute to new ideas.`
  },
  {
    id: 5,
    title: 'Happiness and Flourishing',
    description: `We are committed to continuously improving ourselves and developing our potential. We cultivate and foster the three L’s: listen,
                  listen and listen. Working hard while having fun in the process is our key to success. We flourish because we love what we do.`
  },
  {
    id: 6,
    title: 'Partnership',
    description: `This is one of our core values that symbolizes win-win results, mutual involvement for fruitful collaboration, and our
                  dedication to our partners’ success as it is ours!`
  }
]

const { items: businessCards } = useContent('aboutBusinessGrowCard', defaultBusinessCards)

// иконки заданы в вёрстке: в админке у карточек редактируется текст
const yourBusinessCardData = computed(() => businessCards.value.map((item, index) => ({
  ...defaultBusinessCards[index % defaultBusinessCards.length],
  id: item.id ?? index,
  title: item.title,
  description: item.description,
  imageUrl: item.file?.url || '',
})))

const defaultWorkflow = [
  {
    id: 1,
    title: 'First Contact',
    numIcon: `<div class="w-48 h-full bg-01 bg-no-repeat absolute -right-32 top-12"/>`,
    icon: `<div class="w-6 h-4 bg-first-contact bg-no-repeat mt-1"/>`,
    description: `During our first call, we'll tell you more about our expertise, cases, methodology, etc.,
                  and you can give us more information on your project, needs, and background. We'll then
                  develop a plan for our future collaboration, and our business development manager will become your engagement assistant.`
  },
  {
    id: 2,
    title: 'Project Discussion and Setup',
    numIcon: `<div class="w-48 h-full bg-02 bg-no-repeat absolute -right-32 top-12"/>`,
    icon: `<div class="w-6 h-4 bg-project-discount-and-setup bg-no-repeat mt-1"/>`,
    description: `Our business development manager engages business analytics, development,
                  and design teams to estimate your project and give professional recommendations in case of necessity. The
                  business development manager will also help you with organizational issues, interviews, design and development team gathering, paperwork, etc.`
  },
  {
    id: 3,
    title: 'Development Phase',
    numIcon: `<div class="w-48 h-full bg-03 bg-no-repeat absolute -right-32 top-12"/>`,
    icon: `<div class="w-6 h-4 bg-development-phase bg-no-repeat mt-1"/>`,
    description: `During the active development stage, your single point of contact is our account manager, who will collaborate with you on all issues till the project is finished and delivered to
                 you. Depending on the collaboration model you choose, you can either communicate with our engineers directly or delegate this to the project manager, who will ensure smooth
                 communication.`
  },
  {
    id: 4,
    title: 'Post-project Communication',
    numIcon: `<div class="w-48 h-full bg-04 bg-no-repeat absolute -right-32 top-12"/>`,
    icon: `<div class="w-6 h-4 bg-post-project-communication bg-no-repeat mt-1"/>`,
    description: `We value all clients' feedback and always ask them to evaluate our performance and suggest improvements if needed.
                  Our business development manager will forever remain open to you in case you want to start other projects or need assistance on the finished project.`
  }
]

const { items: workflowSteps } = useContent('aboutWorkflowSection', defaultWorkflow)

const workflowData = computed(() => workflowSteps.value.map((item, index) => ({
  ...defaultWorkflow[index % defaultWorkflow.length],
  id: item.id ?? index,
  title: item.title,
  description: item.description,
})))

const { items: teamMembers } = useContent('teamMember', [])

// Фотографии лежат в вёрстке и подключаются классом bg-<имя файла>.
// Если фото загрузили через админку, показываем его напрямую.
const defaultAvatar = require('@/assets/icons/avatar-placeholder.svg')

// снимок для блока «о нас» загружается в админке; пока его нет — иллюстрация,
// а не фото прежней команды
const defaultGallery = require('@/assets/backgrounds/about-default.svg')
const galleryImage = computed(() => pageData.value[0]?.file?.url || defaultGallery)

const peoplesData = computed(() => {
  return teamMembers.value.map((item, index) => ({
    id: item.id ?? index,
    avatar: item.slug || '',
    photoUrl: item.file?.url || '',
    fullName: item.name,
    position: item.position,
    contacts: 'in',
    linkedin: item.linkedin || '',
  }))
})


// Заголовок страницы и текст блока «свяжитесь с нами» редактируются в админке
const { items: pageData } = useContent('aboutPage', [])
const page = computed(() => pageData.value[0] ?? {})

</script>
<style>
.bg-about {
  background-image: url('~@/assets/backgrounds/about.png');
}
</style>

<style scoped>
.person-photo {
  transition: transform .3s ease, box-shadow .3s ease;
}

.person:hover .person-photo {
  transform: translateY(-6px);
  box-shadow: 0 22px 40px rgba(4, 23, 41, .18);
}

.person-link {
  color: #114474;
  transition: color .2s ease, transform .2s ease;
}

.person-link:hover {
  color: #E8B300;
  transform: translateY(-2px);
}

.join-card {
  transition: border-color .3s ease, box-shadow .3s ease, transform .3s ease;
}

.join-card:hover {
  border-color: #FFCE1F;
  transform: translateY(-6px);
  box-shadow: 0 22px 40px rgba(4, 23, 41, .16);
}

.join-arrow {
  transition: transform .3s ease;
}

.join-card:hover .join-arrow {
  transform: translateX(6px);
}

@media (prefers-reduced-motion: reduce) {
  .person-photo,
  .join-card,
  .join-arrow {
    transition: none;
  }

  .person:hover .person-photo,
  .join-card:hover {
    transform: none;
  }
}
</style>
